
import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { Header } from '../../Components/Layout/Header.jsx'
import { GoBack } from '../../Components/Layout/GoBack.jsx'
import { AccountTabletLinkovi } from '../../Components/Account/AccountTabletLinkovi.jsx'
import { RestrictedAccess } from '../../Components/Layout/RestrictedAccess.jsx'
import { MetaTags } from '../../Components/Layout/MetaTags.jsx'

import './accountObavijesti.less'



export class AccountObavijesti extends React.Component {

    constructor(props) {
        super(props);

        this.state = {}

        this.fetchData = this.fetchData.bind(this);
        this.setData = this.setData.bind(this);
        this.clickMore = this.clickMore.bind(this);
        this.oznaciSveKaoProcitano = this.oznaciSveKaoProcitano.bind(this);
        casino.utils.createPageGoogleTagManagerEvent('Moj Racun', 'Obavijesti', 'casino', this.props.user);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.fetchData();
    }


    fetchData() {
        this.props.showLoadingFn(true);
        var promises = Promise.all([casino.repos.notifikacijeRepo.list(false)]);

        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setData, function (reason) { });

    }

    setData(data) {
        this.setState({ notifikacije: data[0] })
        this.props.showLoadingFn(false);
    }

    componentWillUnmount() {
        this.dataPromises.cancel();
        this.props.showLoadingFn(false);
    }

    clickMore(notifikacija, index) {
        setTimeout(() => window.scroll(0, 0), 150);
        casino.repos.notifikacijeRepo.remove(notifikacija);
        var notifikacije = this.state.notifikacije && this.state.notifikacije.notifikacije;
        notifikacije[index].jeProcitana = true;
        this.setState({
            notifikacije: { notifikacije }
        });
    }

    oznaciSveKaoProcitano() {
        this.props.showLoadingFn(true);
        var toRemove = [];
        var notifikacije = this.state.notifikacije && this.state.notifikacije.notifikacije.map(x => {
            if (!x.jeProcitana) {
                x.jeProcitana = true;
                toRemove.push(casino.repos.notifikacijeRepo.remove(x));
            }
            return x;
        });
        Promise.all(toRemove).then(x => {
            this.props.getNotifikacijeFn();
            this.setState({ notifikacije });
            this.props.showLoadingFn(false);
        });
    }

    renderObavijest(x, i) {

        return [
            <div key={"data" + x.igracNotifikacijaID} className="padding-sides-medium-2">

                <div className={"obavijest-u-listi " + (x.jeProcitana ? ' procitana' : ' nova') + (x.inboxHtml ? ' imaHtml' : ' nemaHtml') + (x.important ? " important" : "")}>
                    <div className="slika"><img src={x.pushSlika}></img></div>
                    <div className="body">
                        <span className={"vrijeme " + (x.important ? "important" : "")}>
                            <span className="bullet"></span>
                            {x.important ? "Važno!" : (casino.utils.dateToDateString(new Date(x.datumKreiranja)) + ' ' + casino.utils.dateToTimeString(new Date(x.datumKreiranja)))}<span className="procitano"></span>
                        </span>
                        <h3>{x.naslov}</h3>
                        <p>{x.pushText.replace("[%FIRST_NAME%]", this.props.user.ime)}</p>
                        <div className="ctas">
                            {x.ctAs && x.ctAs.map(y => <a key={y[1]} className={"cta " + y[0]} href={y[2]}>{y[1]}</a>)}
                        </div>
                    </div>
                    <div className="show-more">
                        <Link onClick={() => this.clickMore(x, i)} to={this.props.getHomePathFn(this.props.route.location, '/obavijesti/' + x.igracNotifikacijaID)}> <span className="icon ico-chevron-right"></span> </Link>
                    </div>
                </div>

            </div >,
            <hr key="sep"></hr>
        ]
    }



    render() {
        var pathName = this.props.route.match.url;
        var obavijestID = this.props.route.match.params && this.props.route.match.params.obavijestID;
        var obavijest = obavijestID && this.state.notifikacije && this.state.notifikacije.notifikacije && this.state.notifikacije.notifikacije.filter(x => x.igracNotifikacijaID == obavijestID)[0];

        if (this.props.user) {
            return <div>
                <MetaTags title="Obavijesti | SuperSport Casino" description={" "} />
                <Route exact path={pathName} render={(route) =>
                    (<Header key="header" {...this.state} {...this.props} headerText={"Obavijesti"} headerBackUrl={this.props.getHomePathFn(this.props.route.location, '/account')}></Header>)} />

                <div className="flex margin-1p-on-tablet">
                    <AccountTabletLinkovi {...this.props} ></AccountTabletLinkovi>


                    {!obavijestID && <div id="page-wrapper" className="white flex-expand-1 border-on-tablet no-padding account-obavijesti-page" style={{ minHeight: '400px' }}>
                        <div className="header-3">
                            <h1 className="text">Obavijesti</h1>
                            {this.state.notifikacije && this.state.notifikacije.notifikacije && this.state.notifikacije.notifikacije.filter(x => !x.jeProcitana).length > 0 && <button onClick={this.oznaciSveKaoProcitano} className="action">Označi sve kao pročitano</button>}
                        </div>
                        {this.state.notifikacije && !this.state.notifikacije.notifikacije && <div className="padding-sides-medium-2 text-center margin-top">Dohvaćanje obavijesti...</div>}
                        {this.state.notifikacije && this.state.notifikacije.notifikacije && this.state.notifikacije.notifikacije.length == 0 && <div className="text padding-sides-medium-2 text-center margin-top">😕 Nisu pronađene obavijesti.</div>}
                        {this.state.notifikacije && this.state.notifikacije.notifikacije && this.state.notifikacije.notifikacije.length > 0 && this.state.notifikacije.notifikacije.map(this.renderObavijest.bind(this))}
                    </div>}
                    {obavijest && <div id="page-wrapper" className="white flex-expand-1 border-on-tablet no-padding  account-obavijesti-page" style={{ minHeight: '400px' }}>
                        <GoBack toUrl={this.props.getHomePathFn(this.props.route.location, '/obavijesti')} className="obavijest-povratak" >
                            <span className="icon ico-back ico-chevron-left"></span><span>Povratak</span>
                        </GoBack>

                        <div className="header-3">
                            <h1 className="text">{obavijest.naslov}<span className="info"><span className="bullet" />{casino.utils.dateToDateString(new Date(obavijest.datumKreiranja)) + ' ' + casino.utils.dateToTimeString(new Date(obavijest.datumKreiranja))}</span></h1>
                        </div>
                        <div className="padding-sides-medium-2">
                            <div className="objavijest-content" dangerouslySetInnerHTML={{ __html: obavijest.inboxHtml }} />
                            <div className="ctas details">
                                {obavijest.ctAs && obavijest.ctAs.map(y => <a key={y[1]} className={"cta " + y[0]} href={y[2]}>{y[1]}</a>)}
                            </div>
                        </div>
                    </div>
                    }
                </div >
            </div >
        } else {
            return <div>
                <Header key="header" {...this.state} {...this.props}></Header>
                <RestrictedAccess {...this.props} />
                {!this.redirectDone && this.state.redirectTo && <Redirect to={{ pathname: this.state.redirectTo, state: this.state.redirectToState }} />}
                {this.redirectDone = true}
            </div>
        }
    }
};
